import { Injectable } from '@angular/core'
import { EventDatesTimingsConvertHook } from '../models/event-dates-timings.convert.hook'
import { EventParser } from '../models/event.model'
import { IsVirtualConvertHook } from '../models/is-virtual.convert.hook'
import { LinksConvertHook } from '../models/links.convert.hook'

@Injectable({
  providedIn: 'root'
})
export class EventParserService {
  constructor() {
    this.initializeEventParsing()
  }

  private initializeEventParsing(): void {
    console.group('Initializing global event parsing convert hooks')
    /**
     * Register conversion hooks
     */
    EventParser.registerGlobalConvertHook(new LinksConvertHook())
    EventParser.registerGlobalConvertHook(new IsVirtualConvertHook())
    EventParser.registerGlobalConvertHook(new EventDatesTimingsConvertHook())
    console.info('Initialized global event parsing convert hooks ' + EventParser.globalConvertHooks)
    console.groupEnd()
  }
}
